export { ns } from './settings.json';
